function initMap() {
  var center = {lat: 51.9177954, lng: 4.5129681};
  var mapElement = document.getElementById('map');

  if (!mapElement) {
    return;
  }

  mapElement.classList.remove('is-loading');
  mapElement.innerHTML = '';

  var locations = [
      ['YUR Locatie Rotterdam', 51.9177954, 4.5129681, 16]
    ];
  var map = new google.maps.Map(mapElement, {
    zoom: 10,
    center: center,
    styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#526e7e"}]},{"featureType":"administrative.country","elementType":"labels.text","stylers":[{"saturation":"18"},{"lightness":"-55"},{"visibility":"simplified"},{"color":"#4484a1"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#c9d8dd"},{"saturation":"50"},{"lightness":"42"},{"gamma":"2.01"},{"weight":"1"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"color": "#b1c5cd"}, {"stroke": "#849fab"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#c2d3d9"},{"visibility":"on"}]}]
  });
  var infowindow = new google.maps.InfoWindow();

  var marker, i;

  for (i = 0; i < locations.length; i++) { 
    marker = new google.maps.Marker({
      position: new google.maps.LatLng(locations[i][1], locations[i][2]),
      map: map,
      icon: '/app/themes/yur/dist/images/marker.png'
    });

    google.maps.event.addListener(marker, 'click', (function(marker, i) {
      return function() {
        infowindow.setContent(locations[i][0]);
        infowindow.open(map, marker);
      }
    })(marker, i));
  }
}
